import { useState, useEffect } from 'react'
import { textReplace } from '@loomhq/loom-embed'

export const useLoomEmbedHtml = (
  value: string,
  height?: number,
  width?: number
): string => {
  const [valueWithLoomEmbed, setValueWithLoomEmbed] = useState(value ?? '')

  useEffect(() => {
    const setEmbedHtml = async () => {
      if (value) {
        const embedHtml = await textReplace(value?.trim(), {
          width: width ?? 500,
          height: height ?? 500
        })
        setValueWithLoomEmbed(embedHtml)
      }
    }
    setEmbedHtml()
  }, [value, height, width])

  return valueWithLoomEmbed
}
